import type { FC } from "react";
import "./MiniSpinner.scss";

interface MiniSpinnerProps {
  label?: string;
}

const MiniSpinner: FC<MiniSpinnerProps> = ({ label = "Loading..." }) => (
  <div className="mini-spinner-wrapper">
    <div className="mini-spinner" />
    <span className="mini-spinner-label">{label}</span>
  </div>
);

export default MiniSpinner;
